import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function GestionMembresClub() {
  const [membres, setMembres] = useState([]);
  const [roles, setRoles] = useState(['Président', 'Secrétaire', 'Trésorier', 'Membre']); // Liste des rôles possibles
  const [clubId, setClubId] = useState('');
  const [clubName, setClubName] = useState(''); // Ajout de l'état pour le nom du club
  const navigate = useNavigate();

  // Vérifier si l'utilisateur est connecté et récupérer l'ID du club depuis le JWT
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/connexion'); // Redirige si pas de token
    } else {
      try {
        const clubData = JSON.parse(atob(token.split('.')[1])); // Décodage basique du token JWT
        setClubId(clubData.id); // Utilise l'ID du club connecté
        fetchMembres(clubData.id);
        fetchClubInfo(clubData.id);
      } catch (error) {
        console.error('Erreur lors du décodage du token', error);
        navigate('/connexion'); // Redirige si le token est corrompu
      }
    }
  }, [navigate]);

  // Charger les informations du club
  const fetchClubInfo = async (clubId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`http://54.36.103.84:5000/api/clubs/${clubId}`, {
        headers: {
          Authorization: `Bearer ${token}` // Envoie du token dans l'en-tête de la requête
        }
      });
      setClubName(response.data.Nom_Club); // Assurez-vous que la propriété `Nom_Club` est correcte
    } catch (error) {
      console.error('Erreur lors de la récupération des informations du club', error);
      if (error.response && error.response.status === 401) {
        alert('Session expirée. Veuillez vous reconnecter.');
        navigate('/connexion');
      }
    }
  };

  // Charger les membres du club
  const fetchMembres = async (clubId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`http://54.36.103.84:5000/api/clubs/Membres/${clubId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setMembres(response.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des membres', error);
      if (error.response && error.response.status === 401) {
        alert('Session expirée. Veuillez vous reconnecter.');
        navigate('/connexion');
      }
    }
  };

  // Gérer la suppression d'un membre du club
  const handleDeleteMember = async (eleveId) => {
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`http://54.36.103.84:5000/api/clubs/membre/${clubId}/${eleveId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      alert('Membre supprimé avec succès');
      fetchMembres(clubId); // Rafraîchir la liste des membres
    } catch (error) {
      console.error('Erreur lors de la suppression du membre', error);
      alert('Échec de la suppression du membre');
    }
  };

  // Gérer la mise à jour du rôle d'un membre
  const handleRoleChange = async (eleveId, newRole) => {
    const token = localStorage.getItem('token');
    try {
      await axios.put(`http://54.36.103.84:5000/api/clubs/membre/role`, {
        Id_Club: clubId,
        Id_Eleve: eleveId,
        Role: newRole
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      alert('Rôle modifié avec succès');
      fetchMembres(clubId); // Rafraîchir la liste des membres
    } catch (error) {
      console.error('Erreur lors de la modification du rôle', error);
      alert('Échec de la modification du rôle');
    }
  };

  return (
    <div className="container">
      <h2>Gestion des membres du club {clubName || 'Chargement...'}</h2>
      <div className="row">
        {membres.map((membre) => (
          <div className="card col-4 mx-auto mb-3" key={membre.Id_Eleves}>
            <div className="card-body">
              <h5 className="card-title">{membre.Prenom_Eleves} {membre.Nom_Eleves}</h5>
              <p>Rôle actuel : {membre.Role}</p>
              <select
                className="form-control mb-3"
                value={membre.Role}
                onChange={(e) => handleRoleChange(membre.Id_Eleves, e.target.value)}
              >
                {roles.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
              <button
                className="btn btn-danger"
                onClick={() => handleDeleteMember(membre.Id_Eleves)}
              >
                Supprimer le membre
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GestionMembresClub;
